<app-header-global></app-header-global>

<div class="row allcontent">
  <div [ngClass]="sidebarCollapsed ? 'col-sm-1 custom_col_1' : 'col-sm-2'">
    <app-side-overlay-menu></app-side-overlay-menu>
  </div>
  <div
    [ngClass]="sidebarCollapsed ? 'col-sm-11 custom_col-sm-11' : 'col-sm-10'"
  >
    <app-hr-page-header
      [heading]="'Employee Exit Requests'"
      [searchPlaceholder]="'Search'"
      [initialSearchQuery]="searchQuery"
      [searchReadonly]="false"
      [showAddButton]="false"
      [showExportButton]="false"
      [showFilterIcon]="false"
      (searchInput)="onSearchInput($event)"
    ></app-hr-page-header>

    <!-- <div class="row empList">
      <div class="col-10">
         <h4 class="custom_heading">Employee Exit Requests</h4> 
      </div>
      <div class="col-2" style="text-align: right;">
          <a class="ndcBtn">NDC Section</a> 
      </div>
   </div> -->
    <table class="employeeTable">
      <tr>
        <th>Employee Name</th>
        <th>Designation</th>
        <th>Manager</th>
        <th>Date of Joining</th>
        <th>Exit Date</th>
        <th>Status</th>
        <th>Action</th>
      </tr>
      <tr *ngFor="let item of filteredTeamData">
        <td>{{ item.employee_name }}</td>
        <td>{{ item.designation }}</td>
        <td>{{ item.manager }}</td>
        <td>{{ item.doj }}</td>
        <td>{{ item.exit_date }}</td>
        <td>
          <div
            style="display: inline-block"
            matTooltip="{{ item.withdrawal_reason }}"
            placement="top"
          >
            <img
              src="{{
                item.action_required
                  ? '../../../assets/images/schedule.svg'
                  : '../../../assets/images/lock.svg'
              }}"
            />

            <button
              [ngClass]="{
                'btn-success approved': item.current_status === 'Approved',
                'btn-warning pending': item.current_status === 'Pending',
                'btn-danger rejected': item.current_status === 'Rejected',
                'btn-danger withdraw': item.current_status === 'Withdraw'
              }"
              [attr.disabled]="!item.action_required ? true : null"
              class="btn actionBtn"
            >
              <ng-container [ngSwitch]="item.current_status">
                <span *ngSwitchCase="'Approved'">Approved</span>
                <span *ngSwitchCase="'Pending'"
                  >Pending by {{ item.current_approval_level }}</span
                >
                <span *ngSwitchCase="'Rejected'"
                  >Rejected by {{ item.current_approval_level }}</span
                >
                <span *ngSwitchCase="'Withdraw'">Withdraw</span>
              </ng-container>
            </button>
          </div>
        </td>
        <!-- <td>{{ item.current_approval_level }}</td>
            <td>{{ item.action_required ? 'Yes' : 'No' }}</td> -->
        <td>
          <div class="dropdown">
            <a
              class=""
              href="#"
              role="button"
              id="dropdownMenuLink"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              :
            </a>
            <ul class="dropdown-menu" aria-labelledby="dropdownMenuLink">
              <!--  -->
              <li *ngIf="item.action_required">
                <a
                  class="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#e-Separation"
                  href="#"
                  (click)="getEmployeeExitDetails(item.exit_form_id, item)"
                  >View Request Details</a
                >
              </li>
              <li>
                <a
                  (click)="getSeparationEmpRequestsDetails(item.employee_id)"
                  class="dropdown-item"
                  data-bs-toggle="modal"
                  data-bs-target="#employeeDetails"
                  href="#"
                  >View Employee Details</a
                >
              </li>
            </ul>
          </div>
        </td>
      </tr>
    </table>
    <div class="noData" *ngIf="showNoRecordsAvailable">
      <img src="../../../assets/images/Empty-cuate 1.svg" />
      <div class="noRecords">
        <p class="heading">No Records Available</p>
        <p class="subHeading">It looks like there's nothing here yet.</p>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <!-- <div class="modal fade" id="e-Separation" tabindex="-1" aria-labelledby="e-SeparationLabel" aria-hidden="true"> -->
  <div
    class="modal fade"
    id="e-Separation"
    tabindex="-1"
    aria-labelledby="e-SeparationLabel"
    aria-hidden="true"
    (hidden.bs.modal)="resetFormProperties()"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="e-SeparationLabel">
            E - Separation
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <form>
            <div class="row">
              <div class="col-12">
                <label style="font-weight: 500 !important; margin-bottom: 1vh"
                  >Reason for exit</label
                >
                <textarea
                  required
                  [(ngModel)]="exitReason"
                  name="exitReason"
                  class="form-control"
                  id="message-text"
                  rows="5"
                  placeholder="Enter your reason here..."
                  disabled
                ></textarea>
              </div>
            </div>
            <div class="row userEnter">
              <div class="col-6">
                <div class="row">
                  <div class="col-4">
                    <label>WhatsApp No.</label>
                    <input
                      [(ngModel)]="whatsappNo"
                      name="whatsAppNumber"
                      type="text"
                      class="form-control"
                      id="whatsApp-number"
                      disabled
                    />
                  </div>
                  <div class="col-8">
                    <label>Add personal E-Mail Id</label>
                    <input
                      [(ngModel)]="personalEmail"
                      name="personalEmail"
                      type="text"
                      class="form-control"
                      id="personal-E-Mail"
                      disabled
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <div class="row">
                  <div class="col-4">
                    <div class="exitDate">
                      <label>resignation Date </label>
                      <!-- <input formControlName="exitDate" type="text" class="form-control"
                                  value="{{resignationDate | date: 'dd/MM/yyyy'}}" disabled> -->

                      <input
                        [(ngModel)]="resignationDate"
                        name="resignationDate"
                        type="date"
                        class="form-control"
                        id="resignationDate"
                        (change)="onResignationDateChange($event.target.value)"
                        [attr.disabled]="!isHrManager ? true : null"
                      />
                    </div>
                  </div>

                  <div class="col-4">
                    <div class="exitDate">
                      <label>Exit Date </label>
                      <input
                        [(ngModel)]="calculatedExitDate"
                        name="exitDate"
                        type="text"
                        class="form-control"
                        [value]="calculatedExitDate | date: 'dd/MM/yyyy'"
                        disabled
                      />
                    </div>
                  </div>
                  <div class="col-4">
                    <label>Proposed exit date </label>

                    <input
                      [(ngModel)]="proposedDate"
                      name="proposedDate"
                      type="date"
                      class="form-control"
                      id="proExDate"
                      (change)="onProposedDateChange($event.target.value)"
                      [attr.disabled]="
                        !(isManager || isHrManager) ? true : null
                      "
                    />
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer-e-Separation">
          <!-- *ngIf="isManager || isHrManager" -->
          <div>
            <div class="row">
              <div class="col-6 bottomBtn">
                <div class="row" *ngIf="objectKeys(approvalTypes).length > 0">
                  <div class="col-12">
                    <label for="approvalType">EL Leave Adjustment</label>
                    <select
                      class="form-select"
                      id="approvalType"
                      [(ngModel)]="approvalType"
                      name="approvalType"
                      [disabled]="!isHrManager"
                      [required]="isHrManager"
                    >
                      <option
                        *ngFor="let key of objectKeys(approvalTypes)"
                        [value]="key"
                      >
                        {{ approvalTypes[key] }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="col-6 bottomBtn" style="font-weight: 500">
                <div class="row">
                  <div class="col-12">
                    <label>Manager Remark</label>
                    <textarea
                      class="form-control"
                      rows="1"
                      [(ngModel)]="remark"
                      name="remark"
                      placeholder="Enter remark..."
                      [disabled]="!isManager"
                      [required]="isManager"
                    >
                    </textarea>
                  </div>
                </div>
              </div>

              <div
                class="col-6 bottomBtn"
                style="font-weight: 500"
                *ngIf="!isManager"
              >
                <div class="col-12 mt-4">
                  <label>HR Remark</label>
                  <textarea
                    class="form-control"
                    rows="1"
                    [(ngModel)]="hrRemark"
                    name="hrRemark"
                    placeholder="Enter remark..."
                    [disabled]="!isHrManager"
                    [required]="isHrManager && hrRemarkRequired"
                  >
                  </textarea>
                </div>
              </div>

              <div
                class="col-6 bottomBtn"
                style="font-weight: 500"
                *ngIf="!isManager && (isHrManager || hrRemarksFileUrl)"
              >
                <div class="col-12 mt-4">
                  <div class="row">
                    <div class="col-12">
                      <label>HR Attachment</label>
                      <input
                        type="file"
                        class="form-control"
                        accept=".pdf,.doc,.docx"
                        (change)="onMailAttachmentChange($event)"
                        [disabled]="
                          !isHrManager ||
                          !mailAttachmentEnabled ||
                          isUploadingAttachment
                        "
                      />

                      <div
                        *ngIf="isUploadingAttachment"
                        class="mt-1 text-muted"
                        style="font-size: 0.9vw"
                      >
                        HR Attachment Uploading ...
                      </div>

                      <div
                        *ngIf="hrRemarksFileUrl && !isUploadingAttachment"
                        class="mt-2 d-flex align-items-center"
                        style="
                          font-size: 0.9vw;
                          gap: 4px;
                          color: #5f269e;
                          flex-wrap: wrap;
                        "
                        [title]="getFileNameFromUrl(hrRemarksFileUrl)"
                      >
                        <span>{{
                          truncateFileName(getFileNameFromUrl(hrRemarksFileUrl))
                        }}</span>
                        <button
                          type="button"
                          class="btn-sm view-btn-outline mail-view-btn"
                          (click)="openHrRemarksFile()"
                        >
                          View
                        </button>
                      </div>

                      <div
                        *ngIf="isHrManager && hrRemarksUploadError"
                        class="mt-1 text-danger"
                        style="font-size: 0.85vw"
                      >
                        {{ hrRemarksUploadError }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-6 bottomBtn" *ngIf="isCeo || isFinalHrManager">
                <div class="row">
                  <div class="col-12" [ngClass]="hrRemarksFileUrl ? 'mt-1' : 'mt-4'">
                    <label>CEO EL Leave Adjustment</label>
                    <div
                      class="d-flex flex-row flex-wrap gap-3 align-items-center mt-1"
                    >
                      <label
                        *ngFor="let key of objectKeys(approvalTypes)"
                        style="
                          display: flex;
                          align-items: center;
                          gap: 8px;
                          margin-bottom: 0;
                          white-space: nowrap;
                        "
                      >
                        <input
                          type="checkbox"
                          style="accent-color: #5f269e"
                          [checked]="isCeoApprovalSelected(key)"
                          [disabled]="!isCeo"
                          (change)="
                            onCeoLeaveAdjustmentChange(
                              key,
                              $event.target.checked
                            )
                          "
                        />
                        {{ approvalTypes[key] }}
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="col-6 bottomBtn"
                style="font-weight: 500"
                *ngIf="isCeo || isFinalHrManager"
              >
                <div class="col-12 " [ngClass]="hrRemarksFileUrl ? 'mt-1' : 'mt-4'">
                  <label>CEO Remark</label>
                  <textarea
                    class="form-control"
                    rows="1"
                    [(ngModel)]="ceoRemark"
                    name="ceoRemark"
                    placeholder="Enter remark..."
                    [disabled]="!isCeo"
                    [required]="isCeo"
                  >
                  </textarea>
                </div>
              </div>
            </div>

            <div class="row align-items-center">
              <div class="col-6 mt-3">
                <div class="d-flex align-items-center">
                  <label class="me-2" style="font-weight:600;">Remaining Earned Leave </label>
                  <span class="remaining-el-box">{{ remainingEL() }}</span>
                </div>
              </div>
              <div class="col-6 text-end bottomBtn mt-3">
                <button
                  type="button"
                  class="btn acknowledge"
                  (click)="submitFormAcknowledge('Approved')"
                >
                  Acknowledge
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    class="modal fade"
    id="employeeDetails"
    tabindex="-1"
    aria-labelledby="employeeDetailsLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5" id="employeeDetailsLabel">
            Employee Details
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="col-sm-12">
            <div class="row profile-card" *ngIf="empSeparation">
              <div class="col paddings">
                <div class="row">
                  <div class="col key">Employee Name</div>
                  <div class="col-4 value">
                    {{ empSeparation.name }}
                  </div>
                  <div class="col key">Employee Code</div>
                  <div class="col-4 value">
                    {{ empSeparation.emp_id | titlecase }}
                  </div>
                </div>
                <div class="row">
                  <div class="col key">Designation</div>
                  <div class="col-4 value">
                    {{ empSeparation.designation }}
                  </div>
                  <div class="col key">Date of Relieving</div>
                  <div class="col-4 value">
                    {{ empSeparation.relieving_date }}
                  </div>
                </div>
                <div class="row">
                  <div class="col key">Personal Contact No</div>
                  <div class="col-4 value">
                    {{ empSeparation.personal_contact_no }}
                  </div>
                  <div class="col key">Personal E-Mail Id</div>
                  <div class="col-4 value">
                    {{ empSeparation.persional_email_id }}
                  </div>
                </div>
                <div class="row">
                  <div class="col key">Date of Joining</div>
                  <div class="col-4 value">
                    {{ empSeparation.doj }}
                  </div>
                  <div class="col key">Date of Resignation</div>
                  <div class="col-4 value">
                    {{ empSeparation.resignation_date }}
                  </div>
                </div>
                <div class="row">
                  <div class="col key">Reporting Manager Name</div>
                  <div class="col-4 value">
                    {{ empSeparation.manager_name }}
                  </div>
                  <div class="col key">Entity</div>
                  <div class="col-4 value">
                    {{ empSeparation.entity }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="promotionHistory">
          <!-- <div class="col-3 promotion" (click)="getPromotions(empSeparation.emp_id)">
               Promotion History
           </div> -->

          <div *ngIf="renderPromotion">
            <div class="modal-header">
              <h1 class="modal-title fs-5" id="employeeDetailsLabel">
                Promotion History
              </h1>
            </div>

            <div class="">
              <div
                class="manage-proposal-wrapper"
                style="
                  width: 600px;
                  max-height: fit-content;
                  overflow-x: hidden !important;
                "
              >
                <div class="row">
                  <div class="col heading">
                    <font color="#555"
                      >{{ promotionData[0].id }}:&nbsp;{{
                        promotionData[0].employee_fullname
                      }}</font
                    >
                  </div>
                </div>
                <div
                  *ngIf="promotionData.length != 0"
                  style="overflow-x: hidden"
                >
                  <div *ngFor="let item of promotionData">
                    <div class="row">
                      <div class="col-3 cycle">
                        {{ item.appraisal_cycle.name }}
                      </div>
                      <div class="col-1">
                        <i
                          class="fa fa-dot-circle-o dot"
                          aria-hidden="true"
                        ></i>
                      </div>
                      <div class="col history">
                        <font color="#999999">{{ item.old_designation }}</font
                        >&nbsp;<i
                          class="fa fa-angle-double-right arrow"
                          aria-hidden="true"
                        ></i
                        >&nbsp;{{ item.new_designation }}
                      </div>
                    </div>
                    <div class="vertical"></div>
                  </div>
                </div>
                <div class="row" *ngIf="promotionData.length == 0">
                  <div class="col no-promotion">No Promotions Yet :\</div>
                </div>
              </div>
              <div class="modal-footer"></div>
            </div>
          </div>

          <!-- <div class="modal-footer">

           
             
            </div> -->
        </div>
      </div>
    </div>
  </div>
</div>
